import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.scss';

function Cover() {

    const [responsive, setResponsive] = useState(window.innerWidth > 1524);
    const videoRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 0.55; // Itt állítod a sebességet (1 = normál, 0.5 = lassabb, 2 = gyorsabb)
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setResponsive(window.innerWidth > 1524);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const scrollToContentCircles = () => {
        const element = document.getElementById('contentcircles');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleButtonClick = () => {
        // A "Szolgáltatások" gomb kattintásra görgetünk a ContentCircles komponenshez
        if (window.location.pathname === '/') {
            scrollToContentCircles();
        } else {
            navigate('/');  // Ha nem az alapoldalon vagyunk, visszanavigálunk és görgetünk
            setTimeout(() => {
                scrollToContentCircles();
            }, 500); // Kis időt hagyunk, hogy az oldal betöltődjön
        }
    };

    return (
        <section id="cover" className="cover-component">
            <video className="cover-video" autoPlay loop muted playsInline>
                <source src="/img/heroVid.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="overlay"></div> 
            <div className="container">
                <div className="textbox-centered" style={{ backgroundColor: responsive ? '' : 'transparent' }}>
                    {responsive ? (
                        <div className="cover-content">
                            <div className="desktop-text">
                                <h1 className="cover-component-title">
                                    Váci Belvárosi Egészségközpont
                                </h1>
                                <h2 className="headline">Szívből, a belváros szívében!</h2>
                                <button className='ctaButton' onClick={handleButtonClick} > Szakrendeléseink </button>
                            </div>     
                        </div>
                    ) : (
                        <div className="desktop-text">
                            <h1 className="cover-component-title">
                                Váci Belvárosi Egészségközpont 
                            </h1>
                            <img src="/img/vbeklogo2.png" className="mobile-logo" alt="VBEK Logo"/>
                            <button className='ctaButton' onClick={handleButtonClick} > Szakrendeléseink </button>
                        </div>
                    )}
                </div>        
            </div>
        </section>
    );
}

export default Cover;
